<template>
  <div id="uinfoprotext" class="o1rem whiteB" style="padding:.5rem">
    <p>感谢您使用朱贝，欢迎您点击查看<i @click="to_page('/registText')">《用户协议》</i>和<i @click="to_page('/PrivacyText')">《隐私政策》</i>，如您同意，请点击“同意”并接受我们的服务，感谢您的信任！</p>
    <p>我们非常重视隐私和个人信息保护。在您使用的过程中，我们可能会对您部分个人信息进行收集、使用和共享。</p>
    <p>1、我们可能会申请系统设备权限收集设备信息、IMEI、IMSI、应用列表、日志信息等设备信息，用于信息推送和安全风控，并申请存储权限，用于下载及缓存相关文件。</p>
    <p>2、我们可能会申请位置权限，用于帮助您在发布的信息中展示位置或丰富信息推荐维度。</p>
    <p>3、上述权限以及摄像头、麦克风、相册、存储空间、GPS等敏感权限均不会默认或强制开启收集信息。</p>
    <p>4、未经您同意，我们不会出售或出租您的任何信息。</p>
    <p>5、您可以访问、更正、删除个人信息，我们也提供账户注销、投诉方式。</p>


    <p></p>
    <p></p>
  </div>
</template>

<script>
export default {
  name: "uinfoprotext",
  data() {
    return {};
  },
  methods: {
     /**跳转其他文本 */
     to_page(name){
       this.$router.push({path:name})
     }
  },
  mounted: function() {
    this.$tool.setTitle("个人信息保护指引");
    this.$emit("closed");
  }
};
</script>

<style scoped>
p {
  font-size: 14px;
  color: #999;
  margin-bottom: 0.4rem;
  line-height: 21px;
  text-align: justify;
}
.title {
  font-size: 15px;
  color: #333;
  text-indent: 0rem;
}
i{
  font-style: normal;
  color: #c159ff;
}
</style>
